export function initShoppingCartInsert()
{
	const changeCountEls = document.querySelectorAll(".change-count");

	changeCountEls.forEach(el => {
		el.addEventListener("click", function(e) {
			e.preventDefault();
			const inputGroupEl = e.target.closest(".input-group");
			const inputEl = inputGroupEl.querySelector("input");
			let inputValue = parseInt(inputEl.value,10);

			if (el.classList.contains("plus")) {
				inputEl.value = inputValue + 1;
			} else {
				if (inputValue > 1) {
					inputEl.value = inputValue - 1;
				}
			}
		})
	})
}
